import React, { useState } from 'react';
import Typography from '@mui/material/Typography';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import {
  Card, CardBody, CardTitleWrap, CardTitle,
} from '@/shared/components/Card';
import { Col } from 'react-bootstrap';
import CurrecnyUploadSheet from './CurrecnyUploadSheet';
import CurrencyTable from './CurrencyTable';

const Currency = () => {
   const [currencyRefresh, setCurrencyRefresh] = useState(false);
  return (
    <div>
      <Breadcrumbs
        aria-label="breadcrumb"
        sx={{
      marginBottom: '5px',
    }}
      >
        <Typography sx={{ color: 'text.primary' }}>Admin</Typography>
        <Typography sx={{ color: 'text.primary' }}>Currency</Typography>
      </Breadcrumbs>
    
      <div className="excel-upload">
        <CurrecnyUploadSheet setCurrencyRefresh={setCurrencyRefresh} />
      </div>
    
      <Col md={12}>
        <Card>
          <CardBody>
            <CardTitleWrap>
              <CardTitle />
            </CardTitleWrap>
          
            <CurrencyTable currencyRefresh={currencyRefresh} setCurrencyRefresh={setCurrencyRefresh} />
          </CardBody>
        </Card>
      </Col>
    </div>
  );
};

export default Currency;
